import { useState } from "react";
import { ForgotOTPForm } from "./ForgotOTPForm/ForgotOTPForm";
import { ForgotPasswordForm } from "./ForgotPasswordForm/ForgotPasswordForm";
import { OTPForm } from "../HomePage/OTPForm/OTPForm";
import { PinGenSection } from "../HomePage/PinGenSection/PinGenSection";
import { WelcomeSection } from "../HomePage/WelcomeSection/WelcomeSection";

export const ForgotPasswordPage = () => {
  const [forgotPasswordStep,setForgotPasswordStep] = useState(0)
  const [userData,setUserData] = useState(null);
  const [authToken,setAuthToken] = useState(null);
  return (
    <>
    {
      forgotPasswordStep==0 && <ForgotPasswordForm setUserData={setUserData} setForgotPasswordStep={setForgotPasswordStep}/>
    }
    {
      forgotPasswordStep==1 && <OTPForm setAuthToken={setAuthToken} userData={userData} isRegisterationTrue={false} setForgotPasswordStep={setForgotPasswordStep}/>
    }
    {
      forgotPasswordStep==2 &&  <PinGenSection authToken={authToken} userData={userData} isRegisterationTrue={false} setForgotPasswordStep={setForgotPasswordStep}/>
    }
    {
      forgotPasswordStep==3 && <WelcomeSection isRegisterationTrue={false} setForgotPasswordStep={setForgotPasswordStep}/>
    }
      {/* <ForgotPasswordForm /> */}
      {/* <ForgotOTPForm /> */}
    </>
  );
};
